export default "__VITE_ASSET__Cb__and7__"